<template>
    <div class="language-switcher">
        <!-- Dutch language link -->
        <a
            :href="languageUrls.nl || '/switch-language/nl'"
            :class="['lang-link', { 'lang-active': $page.props.locale === 'nl' }]"
            :aria-label="$t('dutch')"
        >
            NL
        </a>
        <span class="lang-divider">|</span>
        <!-- English language link -->
        <a
            :href="languageUrls.en || '/switch-language/en'"
            :class="['lang-link', { 'lang-active': $page.props.locale === 'en' }]"
            :aria-label="$t('english')"
        >
            EN
        </a>
    </div>
</template>

<script setup>
import {onMounted, computed} from 'vue';
import {usePage} from '@inertiajs/vue3';

// Get the current page object to access props
const $page = usePage();

// Get language switcher URLs from page props
const languageUrls = computed(() => {
    return $page.props.languageSwitcherUrls || {};
});

// Log the current locale and URLs for debugging
onMounted(() => {
    console.log(`Current locale: ${$page.props.locale}`);
    console.log('Language switcher URLs:', languageUrls.value);
});
</script>

<style scoped>
.language-switcher {
    display: flex;
    align-items: center;
}

.lang-link {
    padding: 0.25rem 0.5rem;
    color: #64748b;
    font-size: 0.875rem;
    font-weight: 500;
    text-decoration: none;
    border-radius: 0.25rem;
    transition: color 0.2s, background-color 0.2s;
}

.lang-link:hover {
    color: #3b82f6;
    background-color: #f1f5f9;
}

.lang-active {
    color: #3b82f6;
    font-weight: 600;
}

.lang-divider {
    margin: 0 0.25rem;
    color: #cbd5e1;
}

@media (prefers-color-scheme: dark) {
    .lang-link {
        color: #94a3b8;
    }

    .lang-link:hover {
        color: #3b82f6;
        background-color: #1e293b;
    }

    .lang-active {
        color: #3b82f6;
    }

    .lang-divider {
        color: #475569;
    }
}
</style>
